import {
  mergeComponents,
  PortableTextComponentsProvider,
  PortableTextReactComponents
} from "@portabletext/react";
import React, { ComponentProps, ReactNode, useMemo } from "react";
import { defaultComponents } from "./components";

type BlockContentComponentsProviderProps = ComponentProps<
  typeof PortableTextComponentsProvider
> & {
  placeholderResolver?: PlaceholderResolverFunction;
};

export const BlockContentComponentsProvider: React.FC<
  React.PropsWithChildren<BlockContentComponentsProviderProps>
> = ({ children, components, placeholderResolver, ...props }) => {
  const memorizedComponents = useMemo(() => {
    return mergeComponents(
      defaultComponents(placeholderResolver) as PortableTextReactComponents,
      components
    );
  }, [components, placeholderResolver]);

  return (
    <BlockContentPlaceholderResolverContext.Provider
      value={placeholderResolver}
    >
      <PortableTextComponentsProvider
        {...props}
        components={memorizedComponents}
      >
        {children}
      </PortableTextComponentsProvider>
    </BlockContentPlaceholderResolverContext.Provider>
  );
};

type PlaceholderResolverFunction = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tokenValues: any | undefined
) => (placeholders: string[]) => NonNullable<ReactNode>;

export const BlockContentPlaceholderResolverContext = React.createContext<
  PlaceholderResolverFunction | undefined
>(undefined);
